function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".cls-french-flag1{fill:none;stroke:#36546b;stroke-miterlimit:10;stroke-width:2px;}.cls-french-flag2{clip-path:url(#clip-path);}.cls-french-flag3{fill:#fa4949;}.cls-french-flag3,.cls-french-flag4,.cls-french-flag5{fill-rule:evenodd;}.cls-french-flag4{fill:#0282c9;}.cls-french-flag5{fill:#fff;}");

var _ref3 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(1.55 4.22)"
}, React.createElement("circle", {
  className: "cls-french-flag1",
  cx: 34,
  cy: 34,
  r: 31.04
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-french-flag2"
}, React.createElement("polygon", {
  className: "cls-french-flag3",
  points: "47.13 0 70.65 0 70.65 75.81 47.13 75.81 47.13 0 47.13 0"
}), React.createElement("polygon", {
  className: "cls-french-flag4",
  points: "0 0 23.62 0 23.62 75.81 0 75.81 0 0 0 0"
}), React.createElement("polygon", {
  className: "cls-french-flag5",
  points: "23.63 0 47.13 0 47.13 75.81 23.63 75.81 23.63 0 23.63 0"
}));

var SvgFrench = function SvgFrench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 70.65 75.81",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/French.36902f73.svg";
export { ForwardRef as ReactComponent };